var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/exec/board",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(5.000000, 4.000000)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 17.25,
    x2: 11,
    y2: 20.25,
    id: "path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 20.25,
    x2: 8,
    y2: 23.25,
    id: "path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 20.25,
    x2: 14,
    y2: 23.25,
    id: "path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path",
    x: 0.5,
    y: 0.75,
    width: 21,
    height: 16.5,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 8,
    x2: 23,
    y2: 8,
    id: "path",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 10.5,
    x2: 23,
    y2: 10.5,
    id: "path",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 13,
    x2: 23,
    y2: 13,
    id: "path",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 18,
    x2: 11,
    y2: 18,
    id: "path",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15.5,
    x2: 11,
    y2: 15.5,
    id: "path",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,19 C23.5772156,18.2671172 22.8551449,17.1228892 21.8337878,15.5673161 C20.8091417,14.2830151 19.6516099,13.7507298 19.2975611,12.7197293 C18.2297835,10.0896913 14.5166371,3.67686919 10.4777713,9.13921101 C9.40422194,9.30397961 8.62148258,9.74967686 8,10.3511516 C9.20604013,10.7318752 10.2959703,11.0071309 11.2704027,11.1774747 C13.4510753,14.0409733 13.5076103,16.4930882 13.8470836,19 L24,19 Z",
    id: "Path-2",
    fill: "CurrentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/board.67cb4b9e0d312595994556b6c8048f98.svg";
export { ForwardRef as ReactComponent };